import React from 'react';
import {withFormik} from "formik";
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {login} from "../state/actions/auth";
import {Link, withRouter} from 'react-router-dom';
import config from "../config";


class LoginForm extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.auth.loginInProgress !== this.props.auth.loginInProgress) {
      if (!this.props.auth.loginInProgress && !this.props.auth.token) {
        if (this.props.auth.token) {
          // Login succeeded
          const manager = this.props.managers[0];

          window.analytics.identify(manager.id, {
            id: manager.id,
            "name": manager.name,
            "email": manager.user.email,
            "phone": manager.phone_number,
          });
          window.FS && window.FS.identify(manager.id, {
            displayName: manager.name,
            email: manager.user.email,
            phone: manager.phone_number,
          });
        } else {
          // Login failed
          this.props.setSubmitting(false);
        }
      }
    }

    if (prevProps.business !== this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    }
  }

  render() {
    const {
      values,
      touched,
      errors,
      isValid,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      submitCount,
      status,
    } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="row justify-content-center">
          <div className={"col-md-12 col-lg-6"}>
            <div className={"form-group"}>
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.email && touched.email ? 'text-input form-control error' : 'text-input form-control'}
              />
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className={"col-md-12 col-lg-6"}>
            <div className={'form-group'}>
              <label htmlFor="password">Password</label>
              <input
                className={"form-control"}
                id={"password"}
                type={"password"}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {submitCount > 0 && !isSubmitting && (
                <small className="error form-text">
                  Invalid email and password combination
                </small>
              )}
              <small><Link to={config.routes.businessForgotPassword}>Forgot Your Password?</Link></small>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className={"col-md-12 col-lg-6"}>
            <button type="submit"
                    className="btn btn-primary btn-xlg btn-block btn-pointer"
                    disabled={isSubmitting || !isValid || this.props.auth.loginInProgress}>
              Log In
            </button>
          </div>
        </div>
      </form>
    )
  }
}


export default connect(
  (state) => ({
    auth: state.auth,
    business: state.business.item,
    managers: state.managers.items,
  }),
  (dispatch) => ({
    login: ({email, password}) => dispatch(login({email, password}))
  })
)(withFormik({
  mapPropsToValues: (props) => ({
    email: '',
    password: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    password: Yup.string()
      .required('Password is required'),
  }),
  handleSubmit: (values, {props}) => {
    props.login({email: values.email, password: values.password});
  }
})(withRouter(LoginForm)));



// WEBPACK FOOTER //
// ./src/parts/LoginForm.js